/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramDto } from './program-dto';


export interface ProgramReferralLightDto { 
    firstName?: string;
    id?: string;
    lastName?: string;
    pcmsKey?: number;
    program?: ProgramDto;
    referralDate?: string;
    referralStatus?: ProgramReferralLightDto.ReferralStatusEnum;
    referralStatusDate?: string;
    version?: number;
}
export namespace ProgramReferralLightDto {
    export const ReferralStatusEnum = {
        Pending: 'PENDING',
        Accepted: 'ACCEPTED',
        Active: 'ACTIVE',
        Completed: 'COMPLETED',
        Cancelled: 'CANCELLED',
        Rejected: 'REJECTED',
        Removed: 'REMOVED'
    } as const;
    export type ReferralStatusEnum = typeof ReferralStatusEnum[keyof typeof ReferralStatusEnum];
}


